import { Fahrrad } from '@gsm/entities';
import { DYNAMIC_FORM_CONTROL_INPUT_TYPE_NUMBER, DYNAMIC_FORM_CONTROL_TYPE_GROUP, DYNAMIC_FORM_CONTROL_TYPE_INPUT, DYNAMIC_FORM_CONTROL_TYPE_SELECT, MATCH_VISIBLE } from '@ng-dynamic-forms/core';
import { TYPE_CUSTOM_FILE_UPLOAD } from '../custom-file-upload/custom-file-upload.model';
import { TYPE_INFO } from '../info/info.model';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';
import { FahrradListeAdditional, FahrradNachweisVorhanden } from './fahrrad-liste.model';

export function FAHRRAD_TEMPLATE_FACTORY(
  fahrrad: Fahrrad,
  {displayFahrradVersperrt = false}: FahrradListeAdditional = {}
): AnyFormControlModel[] {
  const {
    versperrt,
    nachweisStatus,
    nachweisFileList,
    marke,
    alter,
    anschaffungspreis,
    abloeseErwuenscht
  } = fahrrad || {};

  return [
    {
      id:            'versperrt_info',
      type:          TYPE_INFO,
      content:       'War das Fahrrad versperrt?',
      isInstruction: true,
      hidden:        displayFahrradVersperrt
    },
    {
      id:       'versperrt',
      type:     DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      label:    'Versperrt',
      required: true,
      hidden:   displayFahrradVersperrt,
      options:  [
        {
          label: 'Ja, das Fahrrad war versperrt.',
          value: true
        },
        {
          label: 'Nein, das Fahrrad war nicht versperrt.',
          value: false
        }
      ],
      value:    versperrt
    },
    {
      id:            'nachweisStatus_info',
      type:          TYPE_INFO,
      content:       'Ist ein Nachweis über Besitz-/Anschaffungswert vorhanden?',
      isInstruction: true
    },
    {
      id:       'nachweisStatus',
      type:     DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      label:    'Nachweis über Besitz- /Anschaffungswert',
      required: true,
      options:  [
        {
          label: 'Ja, ein Nachweis ist vorhanden.',
          value: FahrradNachweisVorhanden.Vorhanden
        },
        {
          label: 'Ja, ein Nachweis wird nachgebracht.',
          value: FahrradNachweisVorhanden.Nachgebracht
        },
        {
          label: 'Nein, ein Nachweis ist nicht vorhanden.',
          value: FahrradNachweisVorhanden.NichtVorhanden
        }
      ],
      value:    nachweisStatus
    },
    {
      id:           'nachweisFileList',
      type:         TYPE_CUSTOM_FILE_UPLOAD,
      labelTooltip: 'Dokument hinzufügen',
      required:     true,
      value:        nachweisFileList,
      relations:    [
        {
          match: MATCH_VISIBLE,
          when:  [
            {
              id:    'nachweisStatus',
              value: FahrradNachweisVorhanden.Vorhanden
            }
          ]
        }
      ]
    },
    {
      id:        'detaillierteInformationen',
      type:      DYNAMIC_FORM_CONTROL_TYPE_GROUP,
      relations: [
        {
          match: MATCH_VISIBLE,
          when:  [
            {
              id:    'nachweisStatus',
              value: FahrradNachweisVorhanden.NichtVorhanden
            }
          ]
        }
      ],
      group:     [
        {
          id:            'marke',
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          label:         'Marke',
          placeholder:   'Bitte geben Sie die Marke an.',
          required:      true,
          validators:    {
            required:  null,
            alphanum:  null,
            minLength: 2,
            maxLength: 300
          },
          errorMessages: {
            required:  `Bitte geben Sie eine {{label}} ein.`,
            alphanum:  'Bitte geben Sie eine gültige {{label}} ein.',
            minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
            maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
          },
          value:         marke
        },
        {
          id:            'alter',
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          label:         'Alter',
          placeholder:   'Bitte geben Sie das Alter an.',
          required:      true,
          validators:    {
            required:  null,
            maxLength: 50
          },
          errorMessages: {
            required:  `Bitte geben Sie ein Alter ein.`,
            maxLength: 'Bitte geben Sie maximal 50 Zeichen ein.'
          },
          value:         alter
        },
        {
          id:            'anschaffungspreis',
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          label:         'Ursprünglicher Anschaffungspreis',
          placeholder:   'Bitte geben Sie den Ursprünglicher Anschaffungspreis an.',
          prefix:        '€&#160;',
          required:      true,
          inputType:     DYNAMIC_FORM_CONTROL_INPUT_TYPE_NUMBER,
          min:           0,
          step:          0.01,
          validators:    {
            min:       0,
            maxLength: 15
          },
          errorMessages: {
            min:       'Bitte geben Sie eine positive Zahl ein.',
            maxLength: 'Bitte geben Sie maximal 15 Zeichen ein.'
          },
          value:         anschaffungspreis
        }
      ]
    },
    {
      id:            'abloeseErwuenschtInfo',
      type:          TYPE_INFO,
      content:       'Ist eine Ablöse erwünscht?',
      isInstruction: true
    },
    {
      id:       'abloeseErwuenscht',
      type:     DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      required: true,
      label:    'Ablöse',
      options:  [
        {
          label: 'Ja, eine Ablöse ist erwünscht.',
          value: true
        },
        {
          label: 'Nein, eine Ablöse ist nicht erwünscht.',
          value: false
        }
      ],
      value:    abloeseErwuenscht
    }
  ];
}
